<template>
    <div class="form">
        <h4 class="step-title">
            How many tickets have you had in the past three (3) years?
        </h4>
        <div class="step-content d-flex flex-column align-items-center step-button-list wider">
            <button-list v-bind:items="ticketCounts" v-bind:onclick="complete" v-bind:value="lead.autoInsurance.numberOfTicketsInPast3Years"/>
        </div>
    </div>
</template>

<script>
    import ButtonList from "../shared/ButtonList.vue"

    export default {
        name: "TicketsInPast3Years",
        components: {
            ButtonList
        },
        data: function() {
            return {
                ticketCounts: [
                    { text: "None", value: 0 },
                    { text: "1", value: 1 },
                    { text: "2", value: 2 },
                    { text: "3 or more", value: 3 }
                ]
            }
        },
        props: {
            lead: Object
        },
        methods: {
          complete: function(value) {
              this.lead.autoInsurance.numberOfTicketsInPast3Years = value;
              this.$emit("complete", this.$options.name, value);
          }
        }
    }
</script>
